var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 69,
    viewBox: "0 0 72 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4604 17.6538H60.8102C61.7493 17.6538 62.6781 17.8507 63.5365 18.2316C64.3949 18.6125 65.164 19.1691 65.7942 19.8655C66.4244 20.5618 66.9016 21.3825 67.1952 22.2746C67.4888 23.1667 67.5922 24.1104 67.4988 25.0449L65.4821 45.2116C65.3162 46.8703 64.54 48.4082 63.304 49.5268C62.068 50.6454 60.4605 51.2649 58.7935 51.2649H26.6949C25.1403 51.2655 23.6335 50.7273 22.4311 49.7419C21.2288 48.7564 20.4051 47.3847 20.1004 45.8603L14.4604 17.6538Z",
    className: "svgText",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4605 17.6539L11.738 6.75383C11.556 6.027 11.1362 5.38186 10.5455 4.92087C9.95484 4.45988 9.22704 4.20949 8.47775 4.20947H4.3772",
    className: "svgText",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5439 64.7095H31.2662",
    className: "svgText",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4326 64.7095H58.1548",
    className: "svgText",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8a8e88c9b2a422e41453109b16b3499f.svg";
export { ForwardRef as ReactComponent };